module.exports = __webpack_public_path__ + "img/C911.5efcd013.jpg";